module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-5.5965b5bb.png";